import { VSlickCarousel } from 'v-slick-carousel';
import axios from 'axios';
// import TestDriveForm from '../../components/leadForms/TestDrive/TestDriveForm/TestDriveForm.vue';
// import GetFinancingForm from '../../Components/LeadForms/GetFinance/GetFinanceForm/GetFinanceForm.vue';
// import ContactForm from '../../components/LeadForms/ContactForm/ContactForm.vue';
// import TextusForm from '../../components/Shared/TextUs/TextUs.vue';
import { Events, eventBus } from '../../../Events/ConsumerEvents/Events';
// import GetOfferForm from '../../components/LeadForms/GetOfferForm/GetOfferForm/GetOfferForm.vue'; //need to do
// import TextModal from '../../components/shared/TextModal/TextModal.vue'; //need to do
import ShiftDigitalContainer from '../../../Events/ShiftDigital/ShiftDigitalContainer.js';
import ShiftDigitalService from '../../../Events/ShiftDigital/ShiftDigitalService';
import {
  NEW_SPECIAL_OFFERS_BANNER_CAROUSEL_ASSET_NAME,
  SHIFT_DIGITAL_TOYOTA,
} from '@/js/services/ShiftDigital/ShiftDigitalConstants';
// import CtaButtonsLeadForm from '../../components/CtaButtonsLeadForm/CtaButtonsLeadForm.vue'; //need to do

// import * as constants from '../../../store/StoreConstants/KeyFeatureConstants'; //need to do
// import Thousandseperator from '../../filters/Thousandseperator';
import { CtaButtonActionService } from '../../../Services/CtaButtonActionService.js';
import { LEAD_FORM_REWRITES, BMW_DEFAULT_SORT_ORDER } from '@/js/constants/constants';
import EvoxMediaComponent from '@/js/components/EvoxMediaAssets/EvoxMediaComponent.vue';

// import VueMatchHeights from 'vue-match-heights';  //need to do
import { LayoutConstants } from '@/js/constants/LayoutConstants.js';
import { SessionStorageService } from '@/js/services/SessionStorageService.js';
import { isFordDealer, isLincolnDealer } from '../../../Events/FordDirect/FordCookieService.js';
import { clearHeightByElement } from '@/js/services/CommonUtility.js';
import {
  fireGetOfferClickEvent,
  onCommonCarouselArrowClick,
  onCommonLinkLogs,
  trackOfferCommonEvents,
} from '../../../Events/TagManagerServices/TaggingEventForPages.js';
// import { getSlickDirection } from '../../services/SliderService';

import { isVDVEnabledOnSpecialOffers } from '@/js/Components/shared/VdvPanel/service/VdvService';
import { getVehicleDetailsByVin } from '../../../Services/KellyBlueBookService/KellyBlueBookService.js';
import { useThousandseperator } from '../../../Composables/Thousandseperator/Thousandseperator.js';
import { mapWritableState } from 'pinia';
import { useKeyFeatureStore } from '../../../store/KeyFeatureStore/KeyFeatureStore.js';
import { useLeadFormsStore } from '../../../store/LeadForms/LeadFormsStore.js';
import { toggleModal } from '../../../Composables/LeadFormSettings/useLeadFormSettings.js';
import ResizeHandler from '@/js/services/commonResizeEvents';
import { useTextModalStore } from '../../../store/Shared/TextModalStore/TextModalStore.js';
// Vue.use(VueMatchHeights); //need to do

export default {
  data() {
    return {
      shockRotationalSlick: true,
      showArrows: true,
      resizeHandler: '',
      slickDirection: 'next',
      imageBannerWidth: 250,
      imageBannerHeight: 100,
      hideAutomatedSpecialOffers: window.hideAuotmatedSpecials,
      useoverrides: window.digiServiceUseOverrides,
      shiftDigital: '',
      currentSlide: '',
      opentextmodal: false,
      vehicledetails: '',
      paymentdata: '',
      paymentsFrameData: '',
      Disclaimerdata: '',
      TestDriveForm: false,
      GetOfferForm: false,
      ContactForm: false,
      TextForm: false,
      paymentofferlength: 1,
      offerid: '',
      styleid: '',
      vin: '',
      stockNumber: '',
      dealerurl: '',
      salesnumber: window.salesNumber,
      slickOptions: {
        infinite: true,
        groupsToShow: 1,
        groupsToScroll: 1,
        dots: false,
        adaptiveHeight: true,
        autoplay: false,
        autoplaySpeed: 3000,
      },
      offerDesignID: '',
      consumereventid: Events.eventsConstants.getOffer,
      hideVINandStock: window.hideVINandStock,
      hideExpirationDate: window.hideExpirationDate,
      buttonSettings: [],
      buttontype: '',
      themeName: window.themeName ? window.themeName.toLowerCase() : '',
      isSubaru: window.themeName === 'Subaru' && window.enableOEMProgram,
      isLincoln: isLincolnDealer(window.themeName),
      isFord: isFordDealer(window.themeName),
      isGenesis: window.themeName.toLowerCase() === 'genesis',
      isAlfaromeo: window.themeName.toLowerCase() === 'alfa romeo',
      setMatchHeightData: {
        el: [
          '.set-match-height',
          '.setHeight1',
          '.setHeight2',
          '.vehicle-specials-banner',
          '.set-vehicle-slide-height',
        ],
      },
      noVehicleAvailable:
        window.isFdDealer && !(window.CurrentVehicle && window.CurrentVehicle.length > 4),
      pathName: window.location.pathname,
      specialRotatorAnimation: window.specialRotator,
      isauthenticated: window.isauthenticated === 'True',
      heighRankedVehicles: [],
      currentlyLoadedSpecialBanner: '',
      currentDesign: '',
      currentPaymentObject: {},
      showDisclaimerOnLoad: window.showDisclosureInsteadOfLink,
      enableVdvPanel: false,
      hideDownPaymentOnSpecials: window.hideDownPaymentOnSpecials,
    };
  },

  components: {
    VSlickCarousel,

    EvoxMediaComponent,
  },
  props: {
    /**mega menu dynamic section loader used as mixin for menuPreowned component */
    setLoading: {
      type: Function,
      required: false,
      default: () => (status) => console.log(status),
    },
  },
  computed: {
    ...mapWritableState(useKeyFeatureStore, ['isKeyFeturesExits', 'isSpecialsloaded']),
    ...mapWritableState(useLeadFormsStore, ['showTestDriveModal']),
    ...mapWritableState(useTextModalStore, ['showTextModal', 'title', 'text']),
  },
  // filters: {
  //   Thousandseperator,
  // },
  methods: {
    afterChangeWrapper() {
      try {
        if (typeof this.handleAfterChange === 'function') {
          this.resizeHandler.preventAfterChangeDuringResize(this.handleAfterChange)();
        }
      } catch (error) {
        console.error('Error in afterChangeWrapper method:', error);
      }
    },
    handleAfterChange(event, slick, currentSlide) {
      this.currentSlide = currentSlide;
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      onCommonCarouselArrowClick({
        interactionLabel: this.slickDirection,
        interactionValue: `${nextSlide === 0 ? 1 : nextSlide} / ${this.paymentdata?.length}`,
      });
    },
    handleSlickChange() {
      if (this.shiftDigital) {
        let carouselClick = {
          assetPosition: this.currentSlide,
          assetName: NEW_SPECIAL_OFFERS_BANNER_CAROUSEL_ASSET_NAME,
        };

        if (
          ShiftDigitalContainer.currentShiftProgrammeName() &&
          ShiftDigitalContainer.currentShiftProgrammeName().toLowerCase() ===
            SHIFT_DIGITAL_TOYOTA.toLowerCase()
        ) {
          return;
        }

        ShiftDigitalService.shiftDigitalCarouselClick(this.shiftDigital, carouselClick);
      }
    },
    openTestDriveForm(offerid, vin, styleid, paymentObject = {}) {
      toggleModal('showTestDriveModal', true, { styleid: styleid, offerid: offerid, vin: vin });
      let eventModel = {
        ...Events.consumerEventModel,
        consumerEventId: Events.eventsConstants.openedTestDrive,
        offerId: offerid || 0,
        vin: vin || 0,
        styleId: styleid || 0,
        stockNumber: paymentObject.stockNumber,
      };
      Events.logConsumerEvent(eventModel);
      logGoogleBingEvent(
        'landing',
        'testdrive_click',
        'GetFinance',
        1,
        'Landing Rotatioanl Special Banner Testdrive button Click  '
      );
      onCommonLinkLogs({ label: 'Test Drive', url: 'scheduletestdrive' });
    },
    openGetFinancingForm(offerid, vin, styleid, offerDesignID = '', paymentObject = {}) {
      this.GetOfferForm = true;
      this.offerid = offerid;
      this.styleid = styleid;
      this.vin = vin;
      this.offerDesignID = offerDesignID;
      this.currentPaymentObject = paymentObject;
      let eventModel = {
        ...Events.consumerEventModel,
        consumerEventId: Events.eventsConstants.openedGetFinanceing,
        offerId: offerid || 0,
        vin: vin || 0,
        styleId: styleid || 0,
        stockNumber: paymentObject.stockNumber,
      };
      Events.logConsumerEvent(eventModel);
      logGoogleBingEvent(
        'landing',
        'getfinance_click',
        'GetFinance',
        1,
        'Landing Rotatioanl Special Banner GetFinancing button Click  '
      );
    },
    openContactForm(offerid, vin, styleid, paymentObject = {}) {
      toggleModal('showContactUsModal', true, { styleid: styleid, offerid: offerid, vin: vin });
      // this.ContactForm = true;
      this.offerid = offerid;
      this.styleid = styleid;
      this.vin = vin;
      this.currentPaymentObject = paymentObject;
      let eventModel = {
        ...Events.consumerEventModel,
        consumerEventId: Events.eventsConstants.openContactUsForm,
        offerId: offerid || 0,
        vin: vin || 0,
        styleId: styleid || 0,
        stockNumber: paymentObject.stockNumber,
      };
      Events.logConsumerEvent(eventModel);
      logGoogleBingEvent(
        'landing',
        'contact_click',
        'Contactus',
        1,
        'Landing Rotatioanl Special Banner Contactus button Click  '
      );
      onCommonLinkLogs({ label: 'Contact Us' });
    },
    opendisclaimerdata(data) {
      this.Disclaimerdata = data;
      document.getElementById('rotaionalspecialdisclaimermodal').click();
    },
    openDisclaimer(text) {
      this.title = 'Disclosure';
      this.text = text;
      const fdEvents = ShiftDigitalContainer.getShiftDigitalObject();
      if (fdEvents && typeof fdEvents.actionsOnHomePage === 'function') {
        fdEvents.actionsOnHomePage('disclaimer');
      }
      this.showTextModal = true;

      onCommonLinkLogs({ label: 'Disclosure' });
    },
    openTextusForm(offerid, vin, styleid) {
      this.TextForm = true;
    },
    logOfferEvents(offerDetails) {
      try {
        trackOfferCommonEvents({
          category: 'Specials',
          description: `${offerDetails?.offerText1} ${offerDetails?.offerText2} ${offerDetails?.offerText3}`,
        });
      } catch (error) {
        console.log(error);
      }
    },
    openGetoffer(offerid, vin, styleid, offerDesignID = '', paymentObject = {}, offerDetails = '') {
      toggleModal('showGetOfferForm', true, {
        styleid: styleid,
        offerid: offerid,
        vin: vin,
        offercategoryid: 1,
        stockNumber: paymentObject?.stockNumber,
        offerdesignid: offerDesignID,
      });
      this.offerDesignID = offerDesignID;
      // this.GetOfferForm = true;
      // this.offerid = offerid;
      // this.styleid = styleid;
      // this.vin = vin;
      this.currentPaymentObject = paymentObject;
      this.stockNumber = paymentObject.stockNumber;
      logGoogleBingEvent(
        'landing',
        'makeoffer_click',
        'MakeOffer',
        1,
        'Landing Rotatioanl Special Banner Email offer button Click  '
      );
      logGoogleBingEvent(
        'shopperwizard-emailoffer',
        'makeoffer_click',
        'Email Offer',
        1,
        'Email Offer Button Clicked'
      );
      try {
        fireGetOfferClickEvent({
          offerHeading: `${offerDetails?.offerText1} ${offerDetails?.offerText2} ${offerDetails?.offerText3}`,
          offerID: offerid,
        });
      } catch (e) {
        console.error(e);
      }
    },
    bindImageSrc(url, width = 290) {
      if (url) {
        let index = url.indexOf('&width');
        if (index !== -1) {
          let imageUrl = url.substr(0, index).concat('&width=' + width);
          return imageUrl;
        } else {
          return url;
        }
      }
    },
    removePerMonthText(offertext2) {
      return offertext2.replace(/Per month/i, '');
    },
    formatNumberInString(value) {
      if (this.hideDownPaymentOnSpecials && value?.toLowerCase().includes('down payment')) {
        return '';
      }
      let newValue = value;
      const doubleNumber = newValue.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g);
      const obj1 = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      if (doubleNumber) {
        doubleNumber.forEach((item) => {
          const formattedNumber = obj1.format(item.replace(',', ''));
          newValue = newValue.replace('$' + item, formattedNumber.replace(/\.00$/, ''));
        });
      }
      return newValue;
    },
    getPaymentsFrameData() {
      let sliceCount = 1;
      if (window.innerWidth >= 700) {
        sliceCount = 2;
      }

      let paymentsFrameData = [];
      for (let i = 0; i < this.paymentdata.length; i += sliceCount) {
        paymentsFrameData.push(this.paymentdata.slice(i, i + sliceCount));
      }
      return paymentsFrameData;
    },

    openLeadForm(data, offerID, vin, styleID, offerDesignID = '', paymentObject = {}) {
      switch (data) {
        case 'get-offer-CRM':
          this.openGetoffer(offerID, vin, styleID, offerDesignID, paymentObject, this.paymentOffer);
          break;
        case 'contact-dealer':
          this.openContactForm(offerID, vin, styleID, paymentObject);
          break;
        case 'test-drive':
          this.openTestDriveForm(offerID, vin, styleID, paymentObject);
          break;
        default:
          if (LEAD_FORM_REWRITES.some((t) => t === data)) {
            CtaButtonActionService.getCtaButtonAction(data?.toLowerCase(), '', vin);
          } else {
            this.buttontype = data;
            this.offerid = offerID;
            this.styleid = styleID;
            this.vin = vin;
            this.offerDesignID = offerDesignID;
            this.currentPaymentObject = paymentObject;
            this.stockNumber = paymentObject.stockNumber;
          }
          break;
      }
    },
    getCTAButtonSettings() {
      let apiurl = `${window.ApiBaseUrl}/Inventory/GetSpecialCtaSettings?campaignId=${window.campaignId}`;
      axios
        .get(apiurl)
        .then((response) => {
          this.buttonSettings = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getPaymentOfferText(text) {
      let op = 'Per month';
      if (text?.toLowerCase().includes('day')) {
        op = '';
      }
      return op;
    },
    slickLeftClicked() {
      const fdEvents = ShiftDigitalContainer.getShiftDigitalObject();
      if (fdEvents && typeof fdEvents.actionsOnHomePage === 'function') {
        fdEvents.actionsOnHomePage('specials scroll:left');
      }
    },
    slickRightClicked() {
      const fdEvents = ShiftDigitalContainer.getShiftDigitalObject();
      if (fdEvents && typeof fdEvents.actionsOnHomePage === 'function') {
        fdEvents.actionsOnHomePage('specials scroll:right');
      }
    },
    logViewDetailsEvent() {
      const fdEvents = ShiftDigitalContainer.getShiftDigitalObject();
      if (fdEvents && typeof fdEvents.actionsOnHomePage === 'function') {
        fdEvents.actionsOnHomePage('view details');
      }
    },
    isBmw() {
      return LayoutConstants.isBmwTemplate() && window.themeName.toLowerCase() === 'bmw';
    },
    addPerMonth(x, y) {
      return !(
        x.toLowerCase().includes('months') ||
        x.toLowerCase().includes('per month') ||
        y.toLowerCase().includes('months') ||
        y.toLowerCase().includes('per month')
      );
    },

    sortPaymentData() {
      //Sorting Payment data  if vehicle views is in Session storage
      if (!this.isauthenticated && SessionStorageService.getRecentlyviewedVehicles()?.length) {
        this.heighRankedVehicles = SessionStorageService.getRecentlyviewedVehicles();
        this.heighRankedVehicles = this.heighRankedVehicles.sort((v1, v2) => v2.views - v1.views);
        this.paymentdata.sort(this.customSort);
      }

      //Sorting Payment data with default order if No vehicle views is in Session storage
      else if (this.currentlyLoadedSpecialBanner === 'BmwRotationalSpecialBanner') {
        this.heighRankedVehicles = BMW_DEFAULT_SORT_ORDER;
        this.paymentdata.sort(this.customSort);
      } else {
        // No action needed for other cases;
      }
    },

    customSort(vehicleone, vehicletwo) {
      const indexA = this.heighRankedVehicles.findIndex(
        (item) => item.modelName === vehicleone.modelName
      );
      const indexB = this.heighRankedVehicles.findIndex(
        (item) => item.modelName === vehicletwo.modelName
      );
      if (indexA === -1) {
        return 1;
      } else if (indexB === -1) {
        return -1;
      } else {
        return indexA - indexB;
      }
    },
    loadedSpecialBanners() {
      this.currentlyLoadedSpecialBanner = this.$options.name ? this.$options.name : '';
    },

    reInit() {
      if (this.shockRotationalSlick) {
        this.shockRotationalSlick = false;
        this.shockRotationalSlick = true;
        setTimeout(() => {
          this.shockRotationalSlick = false;
        }, 100);
        this.$nextTick(() => {
          this.shockRotationalSlick = true;
        });
      }
      setTimeout(() => {
        this.showArrows = this.$refs.slick?.canGoNext;
        document.dispatchEvent(new CustomEvent('matchheight', this.setMatchHeightData));
      }, 100);
    },
    getModelAndTrimName(paymentdata) {
      if (window.themeName?.toLowerCase() === 'mercedes-benz') {
        let value = '';
        let trim = paymentdata?.trim?.split(' ');
        let model = paymentdata?.modelName?.split(' ');
        let filteredData = trim?.find((_) => model?.some((q) => q === _));

        if (filteredData) {
          value = `${paymentdata?.trim}`;
        } else {
          value = `${paymentdata?.modelName} ${paymentdata?.trim}`;
        }
        return value;
      } else {
        return `${paymentdata.modelName} ${paymentdata.trim}`;
      }
    },
    insertTradeMark(styleName) {
      if (
        window.make.toLowerCase() === 'mercedes-benz' &&
        (styleName?.toLowerCase().includes('4matic') ?? false)
      ) {
        return styleName.replace('4MATIC', '4MATIC®');
      } else {
        return styleName;
      }
    },
    async playVDV(url, vin = '') {
      console.log(url);
      let vehicleDetailsObject = {};
      if (vin) {
        let vehicleDetails = await getVehicleDetailsByVin(vin);
        vehicleDetailsObject = {
          vehicleYear: vehicleDetails?.year || '',
          vehicleMake: vehicleDetails?.make || '',
          vehicleModel: vehicleDetails?.model || '',
          vehicleTrim: vehicleDetails?.trim || '',
        };
      }
      let eventmodel = {
        ...Events.consumerEventModel,
        vin,
        consumerEventId: Events.eventsConstants.VdvSpecialsEvent,
        ...vehicleDetailsObject,
      };

      await Events.logConsumerEvent(eventmodel);

      const playURL = url + '#vdv';
      window.location.href = playURL;
    },
    async isVDVEnable() {
      let isVDVEnable = isVDVEnabledOnSpecialOffers();

      console.log('vdv enable: ', isVDVEnable);
      this.enableVdvPanel = isVDVEnable;
    },
  },
  mounted() {
    // To know which specialBanner is loaded
    this.loadedSpecialBanners();
    if(this.currentlyLoadedSpecialBanner !== "ParagonPrimaryRotationalSpecialBanner"){
          this.getCTAButtonSettings();
    }
    this.isVDVEnable();
    this.resizeHandler = new ResizeHandler();
    this.resizeHandler.addResizeListener();
    this.shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
    this.primarySlickOptions = { ...this.slickOptions };

    this.primarySlickOptions = {
      ...this.primarySlickOptions,
      ...{
        groupsToShow: 1,
        groupsToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              dots: false,
              arrows: true,
              groupsToShow: 1,
              groupsToScroll: 1,
            },
          },
          {
            breakpoint: 391,
            settings: {
              arrows: false,
              groupsToShow: 1,
              groupsToScroll: 1,
            },
          },
        ],
      },
    };

    // these arrows moved to template
    // this.primarySlickOptions.nextArrow = `<em class="arrow-fire primaryicon-right-arrow bgcolor-primary _msbi_background_color test"  style="cursor:pointer;z-index:1;color:#212529;right:-17px;"></em>`;
    // this.primarySlickOptions.prevArrow = `<em class="arrow-fire primaryicon-left-arrow test"  style="color:#cccccc;cursor:pointer;z-index:1;left:-17px;"></em>`;
    if (window.isFdDealer) {
      this.primarySlickOptions = {
        ...this.primarySlickOptions,
        ...{
          groupsToShow: 2,
          groupsToScroll: 2,
          adaptiveHeight: true,
          arrows: true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                groupsToShow: 1,
                groupsToScroll: 1,
              },
            },
          ],
        },
      };
    }
    if (window.vehicleOfferRotationalDelay) {
      this.primarySlickOptions.autoplay = true;
      this.primarySlickOptions.autoplaySpeed = window.vehicleOfferRotationalDelay * 1000;
    }
    this.luxurySlickOptions = { ...this.slickOptions };
    // these arrows moved to template
    // this.luxurySlickOptions.nextArrow = `<em class="primaryicon-right-arrow bgcolor-primary _msbi_background_color" style="cursor:pointer;z-index:1;color:#212529;right:-17px;"></em>`;
    // this.luxurySlickOptions.prevArrow = `<em class="primaryicon-left-arrow" style="color:#cccccc;cursor:pointer;z-index:1;left:-17px;"></em>`;
    this.luxurySlickOptions.dots = true;
    this.simplifySlickOptions = { ...this.slickOptions };
    // these arrows moved to template

    // this.simplifySlickOptions.nextArrow = `<em class="primaryicon-right-arrow bgcolor-primary _msbi_background_color" style="cursor:pointer;z-index:1;color:#212529;right:-22px;"></em>`;
    // this.simplifySlickOptions.prevArrow = `<em class="primaryicon-left-arrow" style="color:#cccccc;cursor:pointer;z-index:1;left:-22px;"></em>`;
    this.simplifySlickOptions.adaptiveHeight = false;
    this.simplifySlickOptions.autoplay = false;

    // this.setLoading(true);
    axios
      .get(
        `${window.ApiBaseUrl}/Offers/BannerOffers?Campaignid=${window.campaignId}&Make=${window.make}&IsContactUrlPassed=true`
      )
      .then((response) => {
        // this.setLoading(false);
        this.vehicledetails = response.data;
        const { Thousandseperator } = useThousandseperator();

        this.vehicledetails = {
          ...response.data,
          formattedMsrp: Thousandseperator(this.vehicledetails?.paymentOffers.msrp),
        };
        // hiding automated specials on banners
        this.paymentdata = this.hideAutomatedSpecialOffers ? [] : this.vehicledetails.paymentOffers;
        if (window.masterLayoutName === '_Website_BMW' && window.researchModelModelName) {
          this.paymentdata = [];
          this.vehicledetails.paymentOffers.map((d) => {
            if (d.modelName.toLowerCase() === window.researchModelModelName.toLowerCase()) {
              this.paymentdata.push(d);
            }
          });
          // this.isSpecialsloaded = 'completed';
          //store.commit(constants.WAIT_FOR_SPECIALS_API_DATA, 'completed');
        }
        this.paymentofferlength =
          this.vehicledetails.paymentOffers.length + this.vehicledetails.featuredOffers.length;
        this.vehicledetails.featuredOffers.map((x) => {
          this.paymentdata.push(x);
        });

        // Sorting paymentdata
        if (this.paymentdata?.length) {
          this.sortPaymentData();
        } else if (window.ismobile) {
          clearHeightByElement('newspecialsrotatioanl');
        } else {
          //No action needed for other cases
        }

        setTimeout(() => {
          this.showArrows = this.$refs.slick?.canGoNext;
          document.dispatchEvent(new CustomEvent('matchheight', this.setMatchHeightData));
        }, 1000);
        // eventBus.$emit('specialsfound', !!this.paymentdata.length);
      })
      .catch(function (error) {
        // this.setLoading(false);
        if (window.ismobile) {
          clearHeightByElement('newspecialsrotatioanl');
        }
        console.log(error);
        // this.isSpecialsloaded = 'completed';
        //store.commit(constants.WAIT_FOR_SPECIALS_API_DATA, 'completed');
      });

    const sliderInterval = setInterval(() => {
      let leftElement = document.querySelector(
        '.vehicle-specials-slider-box .primaryicon-left-arrow'
      );
      let rightElement = document.querySelector(
        '.vehicle-specials-slider-box .primaryicon-right-arrow'
      );
      if (leftElement) {
        clearInterval(sliderInterval);
        leftElement.addEventListener('click', this.slickLeftClicked);
        rightElement.addEventListener('click', this.slickRightClicked);
      }
    }, 200);

    setTimeout(() => {
      console.log('CD : ' + this.currentDesign);
      this.reInit();
    }, 1500);
  },
};
